'use client'

import { Grid, styled } from '@mui/material'
import Image from 'next/image'
import TrustpilotMini from '../../Shared/TrustpilotWidgets/TrustpilotMini'

const TrustpilotMiniWrapper = styled('div')(() => ({
  minHeight: '120px',
  minWidth: '130px'
}))

const containerSx = {
  rowGap: '24px',
  margin: {
    xs: '24px 0 0 0',
    mdplus: '24px 0 0'
  }
}

const itemSx = {
  display: 'flex',
  justifyContent: 'center'
}

const logoStyle = { marginBottom: '24px' }

const HomepageLogos = () => {
  return (
    <Grid container justifyContent="center" alignItems="center" sx={containerSx}>
      <Grid item xs={6} sm={4} sx={itemSx}>
        <Image
          src={`https://cdn.zuto.cloud/assets/images/homepage/desktop/autotrader-preferred-partner-logo.svg`}
          alt="Autotrader Preferred Partner Logo"
          width={148}
          height={44}
          loading="eager"
          style={logoStyle}
        />
      </Grid>
      <Grid item xs={6} sm={4} sx={itemSx}>
        <TrustpilotMiniWrapper>
          <TrustpilotMini id="tag_homepage-trustpilot-mini" style={logoStyle} />
        </TrustpilotMiniWrapper>
      </Grid>
    </Grid>
  )
}

export default HomepageLogos
